import state from './state'
export default {
  state,
  mutations: {
    // 校招详情
    setDetailObj (state, val) {
        state.detailObj = val
    }
  },
  actions: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/sessionInfo/index.js